export default "__VITE_ASSET__jXY6yWu5__"